import AuthService from "../../service";
const serviceArea = {
  getServiceArea(page,search,sort_date,sort_branch) {
    return AuthService.get(`/service/service_area?`+
      `page=${page}` +
      `&sort_date=${sort_date}` +
      `&sort_branch=${sort_branch}` +
      `&search=${search}`
    );
  },
  showServiceArea(id) {
    return AuthService.get("/service/service_area/" + id);
  },
  createServiceArea(data) {
    return AuthService.post("/service/service_area", data);
  },
  updateServiceArea(id, data) {
    return AuthService.put("/service/service_area/" + id, data);
  },
  deleteServiceArea(id) {
    return AuthService.delete("/service/service_area/" + id);
  }
};
export default serviceArea;
